import SubMenu from './SubMenu';
import {Sticky, StickyContainer} from 'react-sticky';
import React,{Component} from 'react';

import './Wrapper.less';

class HeadingMenu extends Component {

  render(){

  const {linkText, linkUrl, menuItems, menuAction,style,isSticky,res} = this.props;

  if(!(linkText && linkText) && !menuItems ){
    return null;
  }
  return(
    <div className={isSticky ? "section-heading-menu sticky" : "section-heading-menu"} style={style}>
      { linkText && linkUrl ? <a href={linkUrl} target="_blank">{linkText}</a> : null}
      { !linkText && menuItems ? <SubMenu menuItems={menuItems} menuAction={menuAction} /> : null }
    </div>
  )
}
}


const Wrapper = (props) => {
  const {title,children,fullwidth,res,id} = props;
  return (
    <div className={"section"} id={id} style={props.style}>
      <div className={`section-heading ${res}`}>
        <h2 className="section-heading-title">{title}</h2>
        { res != 'small' && <HeadingMenu {...props} />}
      </div>
      <div className={fullwidth ? "section-content fullwidth" : `section-content middle ${res}`} >
        {
          res=='medium' || res=='small'
          ? (
            <StickyContainer>
            <Sticky>
            {
              ({ isSticky, wasSticky, style, distanceFromTop, distanceFromBottom, calculatedHeight }) => {
                let style_ = style;
                style_.top = 66;
                style_.zIndex = 80;
                const {linkText, menuItems} = props;
                style_.display = 'none';
                if(isSticky){
                  style_.display = 'block';
                }
                if(!linkText && !menuItems ){
                  return <div />;
                }
                return <HeadingMenu {...props} isSticky={isSticky} style={style_} res={res} />
              }
            }
            </Sticky>
              {children}
            </StickyContainer>)
          : children
        }
      </div>
    </div>
  )
}
export default Wrapper



// WEBPACK FOOTER //
// ./src/components/Wrapper.js